import WGLDrawable from './drawable';

const VANAME_POS = 'vertexPosition';
const VANAME_TEX = 'vertexTex';

class Quad extends WGLDrawable {
  constructor(gl, key) {
    super(key);
    // prettier-ignore
    const bufElt = new Uint16Array([ 0,1,2,  0,2,3 ]);
    // prettier-ignore
    const bufPos = new Float32Array([ -1,-1,0,  1,-1,0,  1,1,0,  -1,1,0 ]);
    // prettier-ignore
    const bufTex = new Float32Array([ 0,0,  1,0,  1,1,  0,1 ]);
    

    super.setGeometry(gl, bufElt, [
      { name: VANAME_POS, size: 3, data: bufPos },
      { name: VANAME_TEX, size: 2, data: bufTex },
    ]);
  }
}

export default Quad;
